import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetSearchParams, mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TabButton({ title, name, active, onClick }) {
    return (
        <button
            type="button"
            onClick={() => onClick(name?.toLowerCase())}
            className={cn(
                `group h-full w-full md:w-auto md:min-w-20 flex justify-center items-center gap-2.5 bg-transparent text-secondary hover:bg-secondary hover:text-white font-medium text-xl focus:outline-none outline-none transition-colors cursor-pointer rounded-md px-3 py-2`,
                {
                    'active bg-secondary text-white': active
                }
            )}
        >
            <span className="inline-block capitalize whitespace-nowrap">{title || name}</span>
        </button>
    );
}

function SubscriptionTableTab({ data }) {
    const navigate = useNavigate();
    const tabName = GetSearchParams('tab') || 'services';
    const [activeTab, setActiveTab] = useState(tabName);

    const tabArr = [
        {
            id: 'services',
            title: 'Services'
        },
        {
            id: 'invoices',
            title: 'Invoices'
        },
        {
            id: 'payments',
            title: 'Payments'
        },
        {
            id: 'support-ticket',
            title: "Support Ticket's"
        },
        {
            id: 'logs',
            title: 'Logs'
        }
    ];

    const handleSetTab = (tab) => {
        setActiveTab(tab);
        navigate(
            mkRelativeUrl(`/subscriptions/manage/${data?.id}/info/`, {
                tab
            })
        );
    };

    return (
        <div
            className={cn(
                'h-13 mb-7 p-[5px] flex sm:inline-flex flex-nowrap justify-start items-center gap-[5px] bg-secondary-100 rounded-10 overflow-auto md:overflow-hidden custom-scrollbar scroll-h-sm',
                {
                    'placeholder-mode': data?.demo
                }
            )}
        >
            {tabArr.map((item) => (
                <TabButton
                    key={item?.id}
                    title={item?.title}
                    name={item?.id}
                    active={activeTab === item?.id}
                    onClick={handleSetTab}
                />
            ))}
        </div>
    );
}

export default SubscriptionTableTab;
